import Information from './Information'
import Setting from './Setting'

const SSL = {
    Information,
    Setting,
}

export default SSL
